import type { BaseDataItem, Spx, CatharsisVariantRelationViewItem } from '@wix/thunderbolt-becky-types'

export const VARIANTS_SEPARATOR = '$$$'

const DESKTOP_SPX: Spx = {
	refWidth: 1280,
	resolverType: 'scale',
}

const MOBILE_SPX: Spx = {
	refWidth: 390,
	resolverType: 'scale',
}

export const getSpxFromBreakpoint = (breakpointId: string) => {
	return breakpointId === 'default' ? DESKTOP_SPX : MOBILE_SPX
}

export const isVariantRelation = <TItem>(item: BaseDataItem): item is CatharsisVariantRelationViewItem<TItem> =>
	item.type === 'VariantRelation'

export const getVariant = <TItem extends BaseDataItem>(
	val: CatharsisVariantRelationViewItem<TItem> | TItem
) => {
	if (!isVariantRelation(val)) {
		return { breakpointId: 'default', variantsKey: '', value: val }
	}

	const seed = { breakpointId: 'default', variantsKey: '', value: val.to }
	return val.variants.reduce((acc, curr) => {
		if (curr.type === 'BreakpointRange') {
			// choose the first breakpoint
			acc.breakpointId = acc.breakpointId === 'default' ? curr.id : acc.breakpointId
		} else {
			acc.variantsKey = acc.variantsKey === '' ? curr.id : `${acc.variantsKey}${VARIANTS_SEPARATOR}${curr.id}`
		}
		return acc
	}, seed)
}
